// to manage xml error
function SaltError (error) {
  this.code = ((error||{}).response||{}).status || -1
  this.name = ((error||{}).response||{}).statusText || 'Unknown'
  this.message = (error||{}).message || 'Unknown remote error'
  this.stack = (error||{}).stack || (new Error()).stack
  this.originalError = error
}
SaltError.prototype = Object.create(Error.prototype)
SaltError.prototype.constructor = SaltError

export { SaltError }



// WEBPACK FOOTER //
// ./src/saltapi/errors.js